/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetDistrictsFilterParameter { 
    /**
     * The code of the district. Partial match.
     */
    code?: string;
    /**
     * The name of the district. Partial match.
     */
    name?: string;
    /**
     * The code of the region. Exact match.
     */
    regionCode?: string;
}

